<template>
  <div id="header-mobile">
    <div id="toggle" @click="handleMenu">
      <div>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    methods: {
      handleMenu() {
        const sideBar = document.getElementById('sideMenuContainer');
        sideBar.classList.toggle("toggle-menu")
      },
    }
  }
</script>
